import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { de_CreateStreamProcessorCommand, se_CreateStreamProcessorCommand } from "../protocols/Aws_json1_1";
export { $Command };
export class CreateStreamProcessorCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("RekognitionService", "CreateStreamProcessor", {})
    .n("RekognitionClient", "CreateStreamProcessorCommand")
    .f(void 0, void 0)
    .ser(se_CreateStreamProcessorCommand)
    .de(de_CreateStreamProcessorCommand)
    .build() {
}
